const DSN_THEME_VARIANTS = ["tpl-dsn3-longtong", "tpl-dsn39696-longtong", "tpl-dsn39797-longtong"];

$(() => {
  const showCorrectAppDownloadQR = () => {
    DSN_THEME_VARIANTS.forEach((themeVariant) => {
      if (window.themeName !== themeVariant) {
        $(`#app-download-member-qr-${themeVariant}`).remove();
      }
    });

    $(".option-button.hidden").removeClass("hidden");
  };

  if (Pace) {
    Pace.on("done", showCorrectAppDownloadQR);
  } else {
    $(window).load(showCorrectAppDownloadQR);
  }
});
